var _circle, _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgAirport(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 58,
    height: 58,
    viewBox: "0 0 58 58",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 29,
    cy: 29,
    r: 29,
    fill: "#FF8C25"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M42.7 16.725C43.6833 17.7083 43.6833 19.2917 42.7 20.2583L36.2167 26.7417L39.75 42.0583L37.4 44.425L30.9333 32.0417L24.4333 38.5417L25.0333 42.6583L23.25 44.425L20.3167 39.125L15 36.175L16.7667 34.375L20.9333 34.9917L27.3833 28.5417L15 22.025L17.3667 19.675L32.6833 23.2083L39.1667 16.725C40.1 15.7583 41.7667 15.7583 42.7 16.725Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAirport);
export default __webpack_public_path__ + "static/media/airport.c3ecf1fba68cca16a1ad9c44bca92142.svg";
export { ForwardRef as ReactComponent };